/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { SelectOptionDataType } from '@hb/finance-ui/src/types/shared';
// import { checkCompanyDetails } from '@/shared/utils/validator';
import { UserVo } from '@/vo/user';
import { CONTACT_SPOUSE_RELATION_CODE } from '@/views_v2/verify-credit/types';
import { ProfileFieldEnum, ProfileInstance } from './types';


// const FormCompanyMessage = '请填写正确的公司名称(不少于5个汉字)';
/** 自营渠道id */
export const SelfCommodityId = '8180';

/** 配偶联系人字段 */
export const ContactSpouseFields = [
  ProfileFieldEnum.CONTACT_NAME,
  ProfileFieldEnum.CONTACT_PHONE,
  ProfileFieldEnum.CONTACT_RELATION,
];
/** 通用固定字段(授信、提现) */
export const CommonFixedFields = [
  ProfileFieldEnum.EDUCATION_DEGREE,
  ProfileFieldEnum.PRE_TAX_MONTH_SALARY,
  ProfileFieldEnum.LIVE_ADDRESS,
  ProfileFieldEnum.LIVE_ADDRESS_DETAILS,
];
/** 生成是列表的fieldName(晋商未婚-2个配偶联系人，如：contactName__0, contactName__1) */
export const createGroupFieldName = (name: keyof Partial<UserVo.PersonalInfo> | string, idx: number): string => `${name}__${idx}`;

/** supplyNeedConfig返回的补充字段: 先排除 'id'、通用固定的字段 */
export const ExcludeDynamicSupplyField = ['id', ...CommonFixedFields];

interface ProfileFieldConfig {
  attrs: {
    name?: ProfileFieldEnum,
    label?: string,
    placeholder?: string,
    value?: unknown,
    options?: SelectOptionDataType[],
    rules?: Record<string, unknown>[],
    isDisableEmergency?: boolean,
    /** 联系人关系组件使用 */
    outErrorMsg?: string,
    /** 联系人姓名组件使用 */
    itemIndex?: number,
    /** 联系人姓名组件使用，后面可以抽离出组件维度的属性 */
    nameTip?: boolean,
    /** 是否为select组件 */
    select?: boolean,
    /** 手机号组件使用，用于校验手机号是否可用 */
    commodityId?: string,
  },
  on?: {
    change?: (value: string) => void,
  }
}

/** field表单配置生成-通用组件new-info-component */
export function generateCommonFieldConfig<T extends ProfileInstance>(
  instance: T,
  filedName: ProfileFieldEnum,
  componentName: string,
  commodityId?: string,
): ProfileFieldConfig | null {
  const { verifyStageContext, formData } = instance;
  const {
    lockSpouseInfo,
    lockNoSpouseInfo,
  } = verifyStageContext || {};

  let isDisableEmergency = false;
  let nameTip = false;
  let outErrorMsg = '';
  let itemIndex;
  if (componentName.indexOf('__') > 0) {
    itemIndex = Number(componentName.split('__')[1]) + 1;
  }
  /** 需要补充配偶联系人信息的场景，联系人1 关系锁死配偶（在前面formData赋值了），联系人2 关系不能选择配偶 */
  if (lockSpouseInfo) {
    /** 联系人1关系不为配偶，联系人2关系为配偶时，维持锁定联系人2关系为配偶，其他均为锁定联系人1关系为配偶 */
    if (formData.contactRelation__0 !== CONTACT_SPOUSE_RELATION_CODE
      && formData.contactRelation__1 === CONTACT_SPOUSE_RELATION_CODE) {
      /** 联系人2 姓名 提示 请确认配偶信息 */
      if (componentName === 'contactName__1') {
        nameTip = true;
      }
      /** 联系人1 关系不能选择配偶 */
      if (componentName === 'contactRelation__0') {
        isDisableEmergency = true;
      }
    } else {
      /** 联系人1 姓名 提示 请确认配偶信息 */
      if (componentName === 'contactName__0') {
        nameTip = true;
      }
      /** 联系人2 关系不能选择配偶 */
      if (componentName === 'contactRelation__1') {
        isDisableEmergency = true;
      }
    }
  } else if (lockNoSpouseInfo) {
    /** 未婚 不需要填写配偶信息时， */
    /** 当用户联系人关系为3 配偶时，提示，在组件内部重置数据 */
    if (instance.formData[componentName as keyof UserVo.PersonalInfo]
      === CONTACT_SPOUSE_RELATION_CODE) {
      outErrorMsg = '请重新选择联系人关系';
    }
    /** 控制组件刨除 配偶 selectOption选项 */
    isDisableEmergency = instance.shouldUpdateContacts;
  }

  switch (filedName) {
    /** 关系 */
    case ContactSpouseFields[2]:
      return {
        attrs: {
          isDisableEmergency,
          outErrorMsg,
        },
      };

    /** 姓名 */
    case ContactSpouseFields[0]:
      return {
        attrs: {
          itemIndex,
          nameTip,
        },
      };
    /** 婚姻状态 */
    case ProfileFieldEnum.MARITAL_STATUS:
      return {
        attrs: {
          select: true,
        },
      };
    /** 手机号 */
    case ContactSpouseFields[1]:
      return {
        attrs: {
          commodityId,
        },
      };
    default:
      return null;
  }
}

export enum DynamicFieldEnum {
  /** 职业 */
  PROFESSION = 'profession',
  /** 所属行业 */
  INDUSTRY = 'industry',
}

/** 自营渠道自定义字段 需由用户选定“职业”后来限定“所属行业”，所以让“职业”前置，可以避免填写“所属行业”后被清空的情况 */
export const makeProfessionBeforeIndustry = (dynamicArr: string[]): void => {
  const professionIndex = dynamicArr.indexOf(DynamicFieldEnum.PROFESSION);
  const industryIndex = dynamicArr.indexOf(DynamicFieldEnum.INDUSTRY);

  /** 若是同时存在这两字段，则进行位置交互 */
  if (professionIndex !== -1 && industryIndex !== -1 && professionIndex > industryIndex) {
    dynamicArr[industryIndex] = DynamicFieldEnum.PROFESSION;
    dynamicArr[professionIndex] = DynamicFieldEnum.INDUSTRY;
  }
};
